<template>
    <div class="option-filter configurator-element">
        <div class="section-header">
            <strong>- {{ $t('optionfilter.title') }} -</strong>
        </div>
        <div v-for="option in options" class="filter" :class="{ 'no-items': !hasData(option)}">
            <div class="fold-down-header" v-on:click="toggle(option)">
                <div class="title">{{ $t('optionfilter.filter.' + option) }}</div>
                <OptionHeader :selectedData="getOptionData(option)"></OptionHeader>
                <div class="dropdown-toggle">
                    <font-awesome-icon :icon="['fas', 'chevron-up']" v-if="isActive(option)"/>
                    <font-awesome-icon :icon="['fas', 'chevron-down']" v-else/>
                </div>
            </div>
            <div class="fold-down" :class="{ active: isActive(option) }">
                <OptionList :optionName="option" :show-reset="option == 'seedings' || option == 'surfaces' || option == 'labels'"></OptionList>
                <div v-if="$t('optionfilter.filter.' + option + '.info') != ''" class="filter-info">
                    {{$t('optionfilter.filter.' + option + '.info') }}
                </div>
                <div v-for="filterId in activeFilters[option]" class="filter-notification">
                    <Icon icon="warning"></Icon>
                    <div class="warning_text">
                        {{ getFilter(filterId).message }}
                    </div>
                </div>
            </div>
        </div>
        <div class="bun-share-control">
            <button @click="submitBun()" class="btn-step third share-data">
                <span class="number">3</span>
                <span class="text" :class="(errors['recipeName'] === false)? 'active': ''">{{ $t('buttons.readyToShare') }}</span>
            </button>

          <button @click="download" class="btn-download">
            <svg style="width:30px;height:30px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" />
            </svg>
            {{ $t('buttons.download') }}
          </button>
        </div>

        <SavePrompt ref="saveprompt" :acceptbutton="$t('buttons.share')" :title="$t('prompt.share.title')"
                    :message="$t('prompt.share.message')"></SavePrompt>
    </div>
</template>

<script>
    import loaderMixin from "@/mixins/loaderMixin";
    import OptionList from "./OptionList";
    import SavePrompt from "./SavePrompt";
    import Icon from "./Icon";
    import OptionHeader from "./OptionHeader";
    import formValidationMixin from "../mixins/formValidationMixin";

    export default {
        name: "OptionFilter",
        components: {
            OptionHeader,
            Icon,
            SavePrompt,
            OptionList
        },
        mixins: [loaderMixin, formValidationMixin],
        data: function () {
            return {
                // first opened tab
                folddownState: '',
                // fields to validate
                validateFields: ['recipeName']
            }
        },
        computed: {
            /**
             * get all active filters
             * @returns {array}
             **/
            activeFilters: function () {
                return this.$store.getters.activeFilters;
            }
        },
        methods: {

            /**
             * @todo check if ids of filter match
             */
            // doFilterConditionMatch: function() {
            //     $store.state[option].filter(o => {
            //         return getFilter(filterId).then.conditions.indexOf(o.id).hidden
            //     })
            // },

            /**
             * check if filter type is active
             */
            isActive: function (type) {
                return (this.folddownState == type);
            },

            /**
             * toogle accordion state
             */
            toggle: function (type) {
                if (this.folddownState == type)
                    this.folddownState = '';
                else
                    this.folddownState = type;
            },

            /**
             * check if any options are assigned to current bun
             */
            hasData: function(optionName) {
                let nOptions = this.$store.getters.activeOptions(optionName).length;

                // if sizes has one or its empty
                if((optionName == 'sizes') && (nOptions <= 1)
                    || (nOptions <= 0))
                    return false;

                return true;
            },

            /**
             * get option data for header
             */
            getOptionData: function (option) {
                let recipeData = this.curRecipe[this.sOptionName(option)];

                let data = {
                    hidden: true,
                    name: '',
                    icon: ''
                };

                // if no recipe data was found
                if((recipeData === undefined) || (recipeData.name === undefined)) {
                    // get special data for seedings and surfaces
                    if((option == 'seedings') || (option == 'surfaces') || (option == 'labels')) {
                        data.hidden = false;
                        data.name = this.$t('optionfilter.resetOption');
                        data.icon = this.$store.state.resetOptionIcon;
                    }
                } else {
                    //set data when ingredient is found
                    data.hidden = recipeData.hidden;
                    data.name = recipeData.name;
                    data.icon = recipeData.icon;
                }

                return data;
            },

            /**
             * get all filters which apply to current option type
             * @returns {array} option filter list
             */
            getFilter: function (id) {
                return this.$store.getters.filterById(id);
            },

            /**
             * handle bun submission
             */
            submitBun: function () {
                // trigger submission status
                this.$store.commit('setSubmissionStatus', true);

                // check if all entry data are corrects
                if (this.isValid()) {
                    this.$refs.saveprompt.show();
                }
            },

            download: function () {
              // trigger submission status
              this.$store.commit('setSubmissionStatus', true);

              // check if all entry data are corrects
              if (this.isValid()) {
                this.$store.dispatch('saveRecipe')
                  .then((response) => {
                    this.$store.commit('showModalCover', false)

                    window.setTimeout(function() {
                      window.open('/postcard/' + response.data.data.hash.substr(3) + '_' + response.data.data.name  + '.jpg' , '_blank').focus();
                    }, 50);

                  })

              }
            }
        }
    }
</script>
